import type { CurrentUser, User } from '@/types/user';

import httpClient from '../utils/httpClient';

interface CurrentUserResponse {
  data: CurrentUser;
}

interface IndexResponse {
  data: User[];
}

export default {
  async index(searchPhrase?: string): Promise<IndexResponse> {
    const { data } = await httpClient.get<IndexResponse>('/api/users', {
      params: {
        searchPhrase
      }
    });

    return data;
  },

  async getCurrentUser(): Promise<CurrentUserResponse> {
    const { data } = await httpClient.get<CurrentUserResponse>('api/users/me');

    return data;
  },

  async getUserLocales(): Promise<Record<string, string>> {
    const { data } = await httpClient.get<Record<string, string>>('locales/translations');

    return data;
  },

  async switchCompany(uuid: string): Promise<void> {
    await httpClient.put('api/users/me', {
      managedCompanyUuid: uuid
    });
  },

  async logout(): Promise<void> {
    const logoutUrl = new URL('logout', import.meta.env.VITE_BACKEND_BASE_URL || window.location.origin);

    window.location.assign(logoutUrl);
  },

  async skipEmailRightsConfirmation(): Promise<void> {
    await httpClient.post('api/users/me/skip_email_rights_confirmation');
  }
};
